<template>
  <v-card>
    <v-card-title>
      <v-layout row>
        <span class="headline mb-0">D/O</span>
        <span class="ml-2">
          <v-checkbox
            :label="this.poNo + ' Only'"
            style="margin-top: 0px; height: 20px"
            v-model="only"
          />
        </span>
      </v-layout>
    </v-card-title>
    <v-data-table
      :headers="headers"
      :items="packages"
      :loading="loading"
      hide-actions
      item-key="id"
    >
      <template slot="items" slot-scope="props">
        <td width="150">{{ props.item.blNo }}</td>
        <td width="150">{{ props.item.doNo }}-{{ props.item.branchCode }}</td>
        <td width="150">{{ props.item.invoiceNo }}</td>
        <td :style="diffStyle('poNo', props.item)" width="150">{{ props.item.poNo }}</td>
        <td width="200">{{ props.item.productCode }}:{{ props.item.productName }}</td>
        <td width="200">{{ props.item.skuCode }}</td>
        <td width="100">{{ props.item.paid === 1 ? '有償' : '無償' }}</td>
        <td width="100">{{ props.item.cartonStartNo }}-{{ props.item.cartonEndNo }}</td>
        <td width="100">{{ props.item.perCartonQty }}</td>
        <td :style="diffStyle('qty', props.item)" width="100">{{ props.item.totalQty }}</td>
        <td width="100">{{ props.item.currencyCode }}</td>
        <td :style="diffStyle('unitPrice', props.item)" width="100">{{ props.item.unitPrice }}</td>
        <td width="100">{{ props.item.doStatus }}</td>
        <td width="100">
          <v-btn
            @click="releaseDo(props.item)"
            v-if="props.item.doStatus === 'DO確定済'"
            v-permit.SHARP_PCD_DO_CANCEL
          >D/O解除</v-btn>
          <!-- <v-btn @click="cancelDo(props.item)" v-if="props.item.doStatus === 'DO解除済'">取消</v-btn> -->
        </td>
      </template>
    </v-data-table>
  </v-card>
</template>
<script>
export default {
  props: ['id'],
  data() {
    return {
      form: {},
      status: { NORMAL: '', CONFLICT: 'PO变更', CANCEL: 'PO取消' },
      headers: [
        { text: 'B/L NO', value: 'blNo', sortable: false },
        { text: 'D/O NO', value: 'doNo', sortable: false },
        { text: 'INV NO', value: 'invoiceNo', sortable: false },
        { text: 'P/O NO', value: 'poNo', sortable: false },
        { text: '品種', value: 'productCode', sortable: false },
        { text: '品番', value: 'skuCode', sortable: false },
        { text: '有償/無償', value: 'paid', sortable: false },
        { text: 'Carton', value: 'cartonStartNo', sortable: false },
        { text: '入り数', value: 'perCartonQty', sortable: false },
        { text: '数量', value: 'totalQty', sortable: false },
        { text: '外貨', value: 'currencyCode', sortable: false },
        { text: '単価', value: 'unitPrice', sortable: false },
        { text: '状态', value: 'doStatus', sortable: false },
        { text: '', value: 'op', sortable: false }
      ],
      results: [],
      loading: false,
      conflictType: 'UNKNOWN',
      conflictFields: [],
      newUnitPrice: null,
      only: true,
      errors: {
        NEXT_MONTH_CAN_NOT_CANCEL: '月が変われば、DO解除作業はできなくなる',
        DATA_FROZEN: '該当諸掛費用が凍結されたため、承認取消ができません。'
      }
    }
  },
  methods: {
    diffStyle(prop, item) {
      if (this.poNo === item.poNo && this.conflictFields.indexOf(prop) !== -1)
        return 'color: red; font-weight: bold; font-size: 16px'
      return ''
    },
    conflict(type, fields, newUnitPrice) {
      this.conflictType = type || 'UNKNOWN'
      this.conflictFields = fields || []
      this.newUnitPrice = newUnitPrice
    },
    releaseDo(item) {
      this.$confirm({ content: '本DOを取り消してよろしいでしょか？' }).then(
        () => {
          this.release(item)
        }
      )
    },
    release(item) {
      this.$http
        .put(`delivery-orders/${item.shipmentId}/cancel-confirm-apply`, {
          cancelReason: 'PO変更/取消'
        })
        .then(() => {
          this.$message('', 'DO解除承認待ち')
          this.load()
        })
        .catch(res => {
          this.$showError(res)
        })
    },
    load() {
      this.loading = true
      this.$http.get(`/delivery-orders/conflict?id=${this.id}`).then(res => {
        this.results = res.data
        this.loading = false
      })
    }
  },
  mounted() {
    this.load()
  },
  computed: {
    poNo() {
      return this.$route.query.poNo
    },
    packages() {
      var arr = []
      this.results.forEach(
        DO =>
          (arr = arr.concat(
            DO.packages.map(pkg => ({
              ...pkg,
              doStatus: DO.status,
              blNo: DO.blNo || '',
              doNo: DO.doNo || '',
              branchCode: DO.branchCode || '',
              invoiceNo: pkg.invoiceNo || '',
              poNo: pkg.poNo || '',
              shipmentId: DO.id
            }))
          ))
      )
      arr.sort((a, b) =>
        (b.blNo + b.doNo + b.branchCode + b.invoiceNo + b.poNo).localeCompare(
          a.blNo + a.doNo + a.branchCode + a.invoiceNo + a.poNo
        )
      )
      if (this.only) {
        arr = arr.filter(pkg => this.poNo === pkg.poNo)
      }

      var obj = []
      return arr.map(pkg => {
        if (!obj[pkg.doNo + pkg.branchCode]) obj[pkg.doNo + pkg.branchCode] = 0
        return {
          ...pkg,
          idx: obj[pkg.doNo + pkg.branchCode]++
        }
      })
    }
  }
}
</script>

